export const FEATURE_NAME = '@zerops/zerops/core/settings-base';

export const DEFAULT_LOCATION_ID = 'eu-central';

export const STACK_NAME_TRANSLATIONS_MAP = {
  object_storage: 'Object storage'
};
